<template>  
    <div v-if="pending">
        <div class="d-flex justify-content-center loading-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
	<div v-else class="container py-5">
        <h2>{{ $t('evaluationCreate') }}</h2>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <RouterLink to="/modelings">
                        {{ $t('home') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="{ name: 'modeling', params: { id: this.$route.params.id } }">
                        {{ modelingName || $t('modelings') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="'/modeling/'+ this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId" >
                        {{ assetTypeName || $t('assetType') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="'/modeling/'+ this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId + '/parameter/' + this.$route.params.parameterId" >
                        {{ parameterName || $t('parameter') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">{{ $t('evaluationCreate') }}</li>
            </ol>
        </nav>
        <div class="row mb-3">
            <div class="col-md-4">
                <label class="form-label" for="name" required>{{ $t('name') }}</label>
                <input v-model="data.name" type="text" class="form-control" id="name" >
            </div>
            <div class="col-md-8">
                <label class="form-label" for="description" required>{{ $t('description') }}</label>
                <input v-model="data.description" type="text" class="form-control" id="description">
            </div>
        </div>
        <div class="mb-3">
            <h4>{{ $t('evaluationFilter') }}</h4>
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col">{{ $t('name') }}</th>
                        <th scope="col">{{ $t('sign') }}</th>
                        <th scope="col">{{ $t('number') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(evaluationFilter, i) in data.parameterEvaluationFilter" class="align-middle" :key="i">
                        <th scope="row"><i class="fa fa-remove" @click="removeEvaluationFilter(i)"></i></th>
                        <td>
                            <select :id="'name_' + o"  class="form-select" v-model="evaluationFilter.name">
                                <option disabled>{{ $t('select') }}</option>
                                <option v-for="(datasetHeader, i) in datasetHeaders" :disabled="datasetHeader.disabled" :key="i" v-bind:value="datasetHeader.name">{{ datasetHeader.alias }}</option>
                            </select>
                        </td>
                        <td>
                            <select v-model="evaluationFilter.sign" class="form-select" :id="'sign_' + o"> 
                                <option value=""></option>
                                <option value="=">=</option>
                                <option value=">">&gt;</option>
                                <option value="<">&lt;</option>
                                <option value=">=">&gt;=</option>
                                <option value="<=">&lt;=</option>
                            </select>
                        </td>
                        <td>
                            <input v-model="evaluationFilter.number" type="number" class="form-control" :id="'number_number' + i">
                        </td>
                    </tr>
                </tbody>
            </table>
            <button class="btn btn-secondary w-25 mx-auto d-block" @click="addEvaluationFilter"><i class="fa-solid fa-plus"></i></button>
        </div>
        <div class="mb-3">
            <h4>{{ $t('classTransformation') }}</h4>
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col">{{ $t('className') }}</th>
                        <th scope="col">{{ $t('startParameter') }}</th>
                        <th scope="col">{{ $t('endParameter') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(parameterClass, i) in parameterClasses" class="align-middle"  :key="i">
                        <td>
                            <input v-model="parameterClass.name" disabled class="form-control" :id="'parameterClass.name_' + i">
                        </td>
                        <td>
                            <input v-model="parameterClass.startParameter" :disabled="i > 0" type="number" class="form-control" :id="'startParameter_' + i">
                        </td>
                        <td>
                            <input v-model="parameterClass.endParameter" @input="updateParameterEvaluationTransformationStart(parameterClass.endParameter, i)"  type="number" class="form-control" :id="'endParameter_' + i">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-grid gap-2 d-md-flex ">
            <button type="button" class="btn btn-primary" @click="onSubmit">{{ $t('create') }}</button>
            <button type="button" class="btn btn-secondary" @click="$router.push({ path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}/parameter/${this.$route.params.parameterId}` })">{{ $t('back') }}</button>
        </div>
    </div>
</template>

<script>
import DatasetApi from "../../api/server/dataset";
import AssetTypeApi from "../../api/server/assetType";
import ModelingApi from "../../api/server/modeling";
import ParameterApi from "../../api/server/parameter";

export default {
    name: "parameterEvaluationCreate",
    watch: {
        $route: "requestData",
    },
    mounted() {
        this.requestData();
    },
    methods: {
        async requestData() {
            this.pending = true;

            var assetType = await AssetTypeApi.assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;

            var dataset = await DatasetApi.datasetDetail(this.$route.params.id, assetType.datasetId);
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];

            var parameterClasses = [];
            var parameter = await ParameterApi.parameterDetail(this.$route.params.id, this.$route.params.parameterId);
            this.parameterName = parameter.name;

            for(var i in parameter.parameterClasses) {
                var parameterClass = parameter.parameterClasses[i];
                parameterClasses.push({ name: parameterClass.name, parameterClassId: parameterClass.id, startParameter: 0.0, endParameter: 0.0 }); 
            }

            this.parameterClasses = parameterClasses;
            var modeling = await ModelingApi.modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;

            this.pending = false;
        },
        async onSubmit() {
            if(this.data.name.length > 0) {
             
                this.data.assetTypeId = this.$route.params.assetTypeId;
                this.data.parameterEvaluationTransformation = this.parameterClasses;
                await ParameterApi.evaluationCreate(this.$route.params.id, this.$route.params.parameterId, this.data);
                this.$router.go(-1);
            } else {
                this.showEmptyNameError();
            }
        },
        updateParameterEvaluationTransformationStart(value, i) {
            var range = this.parameterClasses[i+1];
            if(range) {
                range.startParameter = value;
            }
        },
        getMinStartParameterEvaluationTransformation() {
            var minStartParameter = 0;
            if(this.parameterClasses.length > 0)
            minStartParameter = this.parameterClasses[this.parameterClasses.length -1].endParameter;

            return minStartParameter;
        }, 
        removeEvaluationFilter(rowIndex) {
            this.data.parameterEvaluationFilter.splice(rowIndex, 1);
        },
        addEvaluationFilter() {
            this.data.parameterEvaluationFilter.push({  
                name: "",
                sign: "",
                number: 0
            })
        },
    },
    notifications: {
        showEmptyNameError: { 
            title: 'error',
            message: 'emptyName',
            type: 'error'
        }
    },
    data() {
        return {
            datasetHeaders: [],
            data: {
                name: "",
                description: "",
                parameterEvaluationFilter: [],
                parameterEvaluationTransformation: [],
                id: 0
            },
            modelingName: null,
            assetTypeName: null,
            parameterName: null,
            parameterClasses: [],
            pending: true
        }
    }
};
</script>